import React from 'react';
import _ from 'lodash';
import { Autocomplete, Avatar, colors, Divider, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import generateRandomColor from '../helpers/colorGenerator';
import CommentStatus from './CommentStatus';
import moment from 'moment';
import { LoadingButton } from '@mui/lab';
import Cookies from 'universal-cookie';
import { decode } from 'jsonwebtoken';
import { isFunctionEligible } from '../helpers/eligibilityChecker';
import TrackChanges from './TrackChanges';

const CommentParent = ({ repository, comments, comment, setComment, section, setSection, loadingState, userInfo, addComment, doDeleteComment }) => {
  const cookies = new Cookies();
  const decoded = decode(cookies.get('token'));

  return (
    <Stack
      direction='column'
      sx={{ flex: 1, maxHeight: '100vh', backgroundColor: colors.grey[50], overflow: 'scroll' }}
      justifyContent='space-between'
      p={4}
      spacing={2}
      alignItems='flex-start'
    >
      <Stack direction='column' sx={{ overflow: 'scroll', flex: 1, width: '100%', minHeight: 500 }} spacing={2}>
        {isFunctionEligible(decoded.type, 'add_comment_section') && (
          <Stack direction='column' spacing={2}>
            <Typography variant='body2'>
              <b>Comments</b>
            </Typography>
            <TextField
              value={comment}
              onChange={(e) => setComment(e.currentTarget.value)}
              fullWidth
              multiline
              id='outlined-basic'
              label='Insert your comment here'
              variant='outlined'
            />
            <Autocomplete
              disablePortal
              fullWidth
              id='combo-box-demo'
              value={section}
              onChange={(e, newValue) => setSection(newValue?.label || '')}
              options={[
                { label: 'Summary', id: 'summary' },
                { label: 'Goals', id: 'goals' },
                { label: 'Sectors', id: 'sectors' },
                { label: 'Entity', id: 'entity' },
              ]}
              renderInput={(params) => <TextField {...params} label='Section' />}
            />
            <LoadingButton disabled={loadingState.addComment} loading={loadingState.addComment} onClick={addComment}>
              Add comment
            </LoadingButton>
          </Stack>
        )}
        <Divider sx={{ width: '100%' }} />
        {_.isEmpty(comments) && <Typography>No comments found</Typography>}
        {!_.isEmpty(comments) && (
          <Stack direction='column' alignItems='flex-start' spacing={2}>
            {comments.map((item, index) => (
              <Stack key={index} direction='column' alignItems='flex-start' spacing={2} sx={{ width: '100%' }}>
                <Stack direction='row' spacing={2} sx={{ width: '100%' }}>
                  <Avatar sx={{ bgcolor: generateRandomColor(item?.created_by?.slice(0, 2).toUpperCase()) }}>
                    {item?.created_by?.slice(0, 2).toUpperCase()}
                  </Avatar>
                  <Stack direction='row' alignItems='flex-start' justifyContent='space-between' sx={{ width: '100%' }}>
                    <Stack direction='column'>
                      <Stack direction='row' alignItems='center' spacing={1}>
                        <Typography variant='caption'>{moment(item?.createdAt).format('YYYY-MM-DD HH:mm:ss')}</Typography>
                        <Stack>
                          {userInfo.username === item.created_by && (
                            <LoadingButton
                              loading={loadingState.deleteComment}
                              disabled={loadingState.deleteComment}
                              onClick={() => doDeleteComment(item)}
                              size='small'
                              variant='outlined'
                              color='error'
                            >
                              Delete
                            </LoadingButton>
                          )}
                        </Stack>
                      </Stack>

                      <Typography variant='caption'>
                        <i>@{item?.created_by}</i>
                      </Typography>
                      <Typography variant='body2'>
                        {item?.content?.text} -{' '}
                        <b>
                          <i>{item?.content?.section}</i>
                        </b>
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            ))}
          </Stack>
        )}
      </Stack>
      <Divider sx={{ width: '100%' }} />
      <CommentStatus repository={repository} />
      <Divider sx={{ width: '100%' }} />
      <TrackChanges repository={repository} userInfo={userInfo} />
    </Stack>
  );
};

export default CommentParent;
